import useGetNumberOfDecimalPlaces from '../useGetNumberOfDecimalPlaces';

const useGetFormattedAmount = () => {
  const numberOfDecimalPlaces = useGetNumberOfDecimalPlaces();
  return (amount) => Number(amount).toFixed(numberOfDecimalPlaces);
};

export default useGetFormattedAmount;
